function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Wallet",
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Stroke_1",
  "data-name": "Stroke 1",
  d: "M7.353,5.871H2.937A2.936,2.936,0,1,1,2.937,0H7.353",
  transform: "translate(13.524 6.559)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_3",
  "data-name": "Stroke 3",
  d: "M.64.456H.3",
  transform: "translate(16.321 8.972)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_5",
  "data-name": "Stroke 5",
  d: "M5.724,0h9.428a5.724,5.724,0,0,1,5.724,5.724v7.829a5.724,5.724,0,0,1-5.724,5.724H5.724A5.724,5.724,0,0,1,0,13.553V5.724A5.724,5.724,0,0,1,5.724,0Z",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Stroke_7",
  "data-name": "Stroke 7",
  d: "M0,.456H5.889",
  transform: "translate(4.948 4.495)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

function SvgEarningsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.377,
    height: 20.777,
    viewBox: "0 0 22.377 20.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningsActive);
export default __webpack_public_path__ + "static/media/earnings-active.e8685df5.svg";
export { ForwardRef as ReactComponent };